export default "{\n    \"label\": \"Sensor\",\n    \"options\": {\n        \"true\": \"Has sensor\"\n    }\n}\n"